import React from 'react';
import { UseCaseRow } from 'types/schema';
import ChannelManageOrganism from './ChannelManageOrganism';

/**
 * Route entry for the channel manager.
 *
 * The V3 left-rail manager (`ChannelManageOrganism`) is now the ONLY channel
 * manager. The legacy 4-tab UI and the `feature_channel_manage_v3_enabled` gate
 * were removed in a full cutover — this is a thin pass-through kept so existing
 * route wiring (Center-PWA + a2ui-prototype) stays stable.
 *
 * The `useCases*` props are accepted for backward compatibility but unused: the
 * V3 manager loads its own use-case data.
 */
export interface ChannelManagePageOrganismProps {
  channelId: string;
  onBack: () => void;
  /** @deprecated unused — the V3 manager loads its own use-case data. */
  useCases?: UseCaseRow[];
  /** @deprecated unused. */
  useCasesLoading?: boolean;
  /** @deprecated unused. */
  useCasesError?: string | null;
}

const ChannelManagePageOrganism: React.FC<ChannelManagePageOrganismProps> = ({
  channelId,
  onBack,
}) => <ChannelManageOrganism channelId={channelId} onBack={onBack} />;

export default ChannelManagePageOrganism;
